const TYPE = `[DATE]`;

const TYPES = {
    CHANGE_DATE: `${TYPE} CHANGE DATE`,
    DATE_WILL_CHANGE: `${TYPE} DATE_WILL_CHANGE`,
}

export default TYPES;